import type { FC } from "react";

import { FormTextArea as UIFormTextArea } from "@jti/ui/components/ContactForm";

import type { formTextAreaInputs } from "./FormTextArea.builder";

export type FormTextAreaProps = BuilderComponentProps<typeof formTextAreaInputs>;

export const FormTextArea: FC<FormTextAreaProps> = ({
  id,
  label,
  placeholder,
  required,
  requiredMessage,
  disclaimer,
}) => {
  return (
    <UIFormTextArea
      id={id}
      dataTestId={id}
      label={label}
      placeholder={placeholder}
      disclaimer={disclaimer}
      validationRules={{
        required: required ? requiredMessage || true : false,
      }}
    />
  );
};
